import { ICONS, type IconData, type IconName } from "./data";
import { cx } from "../utils/format";

export type { IconName };
export type IconSize = "xs" | "sm" | "md";

/** Material Symbols entries are a single filled path on the 960 grid; hand-drawn entries carry their own viewBox and may mix stroked and filled
 *  paths; a brand mark also carries the transform that fits it onto the 24-unit grid. */
export function Icon({ name, size = "md", className }: { name: IconName; size?: IconSize; className?: string }) {
  const data: IconData = ICONS[name];
  const cls = cx("ob-icon", size !== "md" && `ob-icon--${size}`, className);
  if (typeof data === "string") return <svg className={cls} viewBox="0 -960 960 960" fill="currentColor" aria-hidden="true"><path d={data} /></svg>;
  const paths = data.paths.map((p, i) => p.stroke
    ? <path key={i} d={p.d} fill="none" stroke="currentColor" strokeWidth={p.stroke} strokeLinecap="round" strokeLinejoin="round" />
    : <path key={i} d={p.d} fill="currentColor" />);
  const transform = "transform" in data ? data.transform : undefined;
  return <svg className={cls} viewBox={data.viewBox} aria-hidden="true">{transform ? <g transform={transform}>{paths}</g> : paths}</svg>;
}
